<template>
    <div id="menuLinks">
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'admin_signatures'})">Andamento</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'admin_publications'})">Publicações</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'admin_users'})">Usuários</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'admin_orders'})">Pedidos</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <a href="#" @click="redirectURL({name: 'admin_expeditions'})">Expedições</a>
            </li>
            <li class="list-inline-item dot">|</li>
            <li class="list-inline-item">
              <div class="dropdown">
                <a class="dropdown-toggle"
                   id="dropdownMenuButton"
                   data-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">Relatórios</a>

                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">

                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'order_prefix', params: { prefix:'null' }})">Pedidos por prefixo</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'paid_orders'})">Pedidos concluídos</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'publication_price'})">Lista de preços</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'expedition_list'})">Expedição</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'expired_signatures'})">Assinaturas vencidas</a>

                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'report_signatures', params: {status_type: '1'}})">Vendas</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'report_product'})">Produtos</a>
                  <a class="dropdown-item" href="#" @click="redirectURL({name: 'report_client'})">Clientes</a>
                  
                </div>
            </div>
            </li>
            <li class="list-inline-item dot">|</li>
    </div>
</template>

<script>
  import mixins from "../../../helpers/mixins";
  export default {
    name: "linksMenuAdmin",
    mixins: [mixins],
      
  }
   

</script>

<style scoped>

</style>
